import { FormInstance } from 'antd';
import { RcFile } from 'antd/es/upload';
import { UploadFile } from 'antd/lib';
import dayjs from 'dayjs';
import { User } from 'domain/entities/UserEntity';
import { AlertModalProps, ConfirmModalProps } from 'presentation/components/Modal/Modal.type';
import { ACCOUNT_RANK, PRIVATE_ROUTES_RANK } from 'presentation/router/CONSTANTS';
import queryString from 'query-string';
import { CONFIRM_PROPS, formatMessage } from './constants/MESSAGE';
import { FILE_EXTENSION } from '../infrastructure/config/CONSTANTS';
import { matchPath } from 'react-router-dom';
const IS_NOT_CHARACTERS = /[^a-zA-Z0-9]/g;
const PUBLIC_PATHS_WITH_DYNAMIC_ID = [
    '/app/listing-property-details/:id',
]
export const commonHelpers = {
    preventInputJapanese: (e: React.ChangeEvent<HTMLInputElement>, form: any, name: any) => {
        if (e?.target?.value) {
            const value = e.target.value;
            //check if the char is not a number or a letter
            if (IS_NOT_CHARACTERS.test(value)) {
                //remove the char from the input
                e.target.value = value.replace(IS_NOT_CHARACTERS, '');
                //update the form
                if (form && name) {
                    form.setFieldValue(name, e.target.value);
                }
            }
            if (e.target.value.length > Number(e.target.getAttribute('maxLength'))) {
                e.target.blur();
            }
        }
    },
    formatPhoneNumber: (value: string) => {
        if (value.length === 10)
            return (
                value
                    .slice(0, 6)
                    .match(/.{1,3}/g)
                    ?.join('-') +
                '-' +
                value.slice(6, 10)
            );
        if (value.length === 11)
            return (
                value.slice(0, 3) +
                '-' +
                value
                    .slice(3, 11)
                    .match(/.{1,4}/g)
                    ?.join('-')
            );
        if (value.length > 11) {
            return value.match(/.{1,4}/g)?.join('-');
        }
        return value;
    },
    toLowerCaseNonAccentVietnamese(str: string) {
        str = str.toLowerCase();
        str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
        str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
        str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
        str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
        str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
        str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
        str = str.replace(/đ/g, 'd');
        // Some system encode vietnamese combining accent as individual utf-8 characters
        str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ''); // Huyền sắc hỏi ngã nặng
        str = str.replace(/\u02C6|\u0306|\u031B/g, ''); // Â, Ê, Ă, Ơ, Ư
        return str;
    },
    parserInputNumber: (value: string) => value.replace(/\$\s?|(,*)/g, ''),
    formatInputNumber: (value: string) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
    typeInteger: (event: any) => {
        if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
        }
    },
    typeIntegerSubtract: (event: any) => {
        if (!/[0-9-]/.test(event.key)) {
            event.preventDefault();
        }
    },
    typeFraction: (event: any) => {
        if (!/[0-9.]/.test(event.key)) {
            event.preventDefault();
        }
    },
    typeFractionSubtract: (event: any) => {
        if (!/[0-9.-]/.test(event.key)) {
            event.preventDefault();
        }
    },
    typePhoneNumber: (event: any) => {
        if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
        }
    },
    typeFractionWithMaxLength: (event: any, maxLength: number) => {
        const value = event.target.value + event.key;
        const arrayValue = value.replaceAll(',', '').split('.');
        if (
            !/[0-9.]/.test(event.key) ||
            arrayValue.length > 2 ||
            (arrayValue.length === 2 &&
                (arrayValue[0].length > maxLength || arrayValue[1].length > 2)) ||
            (arrayValue.length === 1 && arrayValue[0].length > maxLength)
        )
            return event.preventDefault();
    },
    toPhoneNumberFormat: (value: string) => {
        const match = value.replace(/\D+/g, '').match(/([^\d]*\d[^\d]*){1,12}$/)?.[0];
        if (!match) return value;
        const part1 = match.length > 3 ? `${match.substring(0, 4)}` : match;
        const part2 = match.length > 4 ? `-${match.substring(4, 8)}` : '';
        const part3 = match.length > 8 ? `-${match.substring(8, 12)}` : '';
        return `${part1}${part2}${part3}`;
    },
    toPostCodeFormat: (value: string) => {
        const postcodeFormat = 'xxx-xxxx';
        const val = commonHelpers.getOriginStringWithPattern(postcodeFormat, value);
        return commonHelpers.formatStringWithPattern(postcodeFormat, val);
    },
    typeRomanji: (event: any) => {
        if (IS_NOT_CHARACTERS.test(event.key)) {
            event.preventDefault();
        }
    },
    changeRomanji: (value?: any) => {
        if (value) {
            //check if the char is not a number or a letter
            if (IS_NOT_CHARACTERS.test(value)) {
                //remove the char from the input
                return value.replace(IS_NOT_CHARACTERS, '');
                //update the form
            }
            return value;
        }
        return value;
    },

    beforeUpload: (file: RcFile) => {
        const isJpgOrPng =
            file.type === 'image/jpeg' ||
            file.type === 'image/png' ||
            file.type === 'application/pdf' ||
            file.type === 'image/jpg';
        if (!isJpgOrPng) {
            //message.error(MESSAGE.MESSAGE_UPLOAD_WRONG_FILE_2);
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            //message.error(MESSAGE.MESSAGE_IMAGE_TOO_LARGE);
        }
        return isJpgOrPng && isLt2M;
    },
    roundFloatNumber: (num: number, decimal: number) => {
        if (Number.isInteger(num)) return num;
        return num.toFixed(decimal);
    },
    formatNumberMoney: (value?: any, fraction?: number): string => {
        if (!value) return '0';
        return Number(value).toLocaleString('en-US', { maximumFractionDigits: fraction ?? 3 });
    },
    toNumberOnly: (value?: any): any => {
        if (!value) return value;
        //remove all non digit characters and decimal separator
        value = (value + '').replace(/[^\d.]/g, '');
        return value;
    },
    formatMoney: (value?: any, fraction?: number): string => {
        if (!value) return '0';
        return Number(value).toLocaleString('en-US', { maximumFractionDigits: fraction ?? 2 });
    },
    roundTenThousandYen: (value?: number) => {
        if (!value) return 0;
        const tenThousandYen = Math.floor(value / 10000);
        const remainder = value % 100000;
        const hundredThousandYen = Math.floor(tenThousandYen / 10);
        if (remainder <= 10000) {
            // round down
            return hundredThousandYen * 10;
        } else {
            // round up
            return (hundredThousandYen + 1) * 10;
        }
    },
    roundTenThousandYenFormat: (value?: number) => {
        if (!value) return 0;
        const tenThousandYen = Math.floor(value / 10000);
        const remainder = value % 100000;
        const hundredThousandYen = Math.floor(tenThousandYen / 10);
        if (remainder <= 10000) {
            // round down
            return commonHelpers.formatNumberMoney(hundredThousandYen * 10);
        } else {
            // round up
            return commonHelpers.formatNumberMoney((hundredThousandYen + 1) * 10);
        }
    },
    convertTenThousandYenDown: (value?: number) => {
        if (!value) return 0;
        return Math.floor(value / 10000);
    },
    formatTenThousandYenDown(value?: number, fraction?: number) {
        if (!value) return '0';
        return commonHelpers.formatNumberMoney(Math.floor(value / 10000), fraction);
    },
    createArray: (start: number, end: number) => {
        const result: number[] = [];
        for (let i = start; i <= end; i++) {
            result.push(i);
        }
        return result;
    },
    onBlurTrimFormItem: (form: FormInstance<any>, formName: string) => {
        if (form.getFieldValue(formName))
            form.setFieldValue(formName, form.getFieldValue(formName).trim());
    },

    convertObjectToFormData: (obj: any) => {
        const formData = new FormData();
        for (const property in obj) {
            if (obj[`${property}`] !== undefined) {
                if (obj[`${property}`] instanceof Array) {
                    obj[`${property}`].forEach((item: any) => {
                        if (item !== undefined) {
                            formData.append(`${property}[]`, item);
                        }
                    });
                } else {
                    formData.append(property, obj[`${property}`]);
                }
            }
        }
        return formData;
    },

    openGoogleMap: (lat?: number, lng?: number) => {
        if (lat && lng) {
            window.open(
                `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`,
                '_blank',
                'noopener,noreferrer',
            );
        }
    },

    getConfirmProps: (modalId?: string, baseProps = {} as ConfirmModalProps, ...args: any[]) => {
        let confirmProps: ConfirmModalProps = {
            ...baseProps,
            open: true,
            onCancel: baseProps.onCancel,
            onOk: baseProps.onOk,
        };
        if (modalId && CONFIRM_PROPS[modalId as keyof typeof CONFIRM_PROPS]) {
            const modalProps = CONFIRM_PROPS[modalId as keyof typeof CONFIRM_PROPS];
            const { message } = modalProps;
            const formatedMessage = formatMessage(message, ...args);
            confirmProps = {
                ...confirmProps,
                ...modalProps,
                message: formatedMessage,
            };
        } else {
            confirmProps = {
                ...confirmProps,
                ...{
                    type: 'success',
                    title: modalId,
                },
            };
        }
        return confirmProps;
    },

    getAlertPropsByErrCode: (errCode?: string, baseProps = {} as AlertModalProps) => {
        let alertProps = {
            ...baseProps,
            open: true,
        };
        if (errCode && CONFIRM_PROPS[errCode as keyof typeof CONFIRM_PROPS]) {
            alertProps = {
                ...alertProps,
                ...CONFIRM_PROPS[errCode as keyof typeof CONFIRM_PROPS],
            };
        }
        return alertProps;
    },

    calculateAge: (dateOfBirth?: string): string => {
        if (dateOfBirth) {
            const ageInMilliseconds = Date.now() - new Date(dateOfBirth).getTime();
            const ageInDate = new Date(ageInMilliseconds);
            return Math.abs(ageInDate.getUTCFullYear() - 1970).toString();
        }
        return '';
    },

    diffDate: (dateFrom: Date, dateTo: Date): number => {
        const diffTime = Math.abs(dateFrom.getTime() - dateTo.getTime());
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays;
    },

    diffDayBetween2Date: (dateFromStr?: any, dateToStr?: any): number => {
        if (!dateFromStr || !dateToStr) return 0;
        const dateFrom = new Date(dateFromStr);
        const dateTo = new Date(dateToStr);
        return commonHelpers.diffDate(dateFrom, dateTo);
    },

    generateQueryString: (params: any) => {
        return queryString.stringify(params);
    },
    /**
     * Return a currying function with given pattern to format input string
     *
     * For example:
     * ```js
     * patternFormat('xxx.xxxx.xxxx.xx')('1231234123412')
     * // => '123.1234.1234.12'
     * patternFormat('xxx xxx xxxx')('1234567')
     * // => '123 456 7'
     * patternFormat('(xxx) xxx xxxx')('1231231234')
     * // => '(123) 123 1234'
     * patternFormat('YYYY-MM-DD HH:mm:ss')('20220520105430')
     * // => '2022-05-20 10:54:30'
     * patternFormat('$00.00')('1234')
     * // => '$12.34'
     * ```
     *
     * @param {string} pattern
     */
    formatStringWithPattern: (pattern: string, str?: string) => {
        if (!str) return str;
        let result = '';
        let i = 0;
        const sections = commonHelpers.patternFormat(pattern);
        for (const section of sections) {
            // end if all characters in "str" are consumed
            if (i >= str.length) break;

            if (typeof section === 'number') {
                result += str.substring(i, i + section);
                i += section;
            } else {
                result += section;
            }
        }
        // concat rest characters.
        if (i < str.length) {
            result += str.substring(i);
        }
        return result;
    },
    getOriginStringWithPattern: (pattern: string, str?: string) => {
        if (!str) return str;
        let result = '';
        let i = 0;
        const sections = commonHelpers.patternFormat(pattern);
        for (const section of sections) {
            // end if all characters in "str" are consumed
            if (i >= str.length) break;
            if (typeof section === 'number') {
                result += str.substring(i, i + section);
                i += section;
            } else if (str.indexOf(section) === i) {
                i += section?.length;
            }
        }
        // concat rest characters.
        if (i < str.length) {
            result += str.substring(i);
        }
        return result;
    },
    patternFormat: (pattern: string) => {
        // convert pattern into block sections: 'xxx xxxx xxxx' => [3, ' ', 4, ' ', 4]
        const sections: any[] = [];
        let i = 0;
        let prevPlaceholder = undefined;
        for (const c of pattern) {
            const placeholder = /[a-zA-Z0-9]/.test(c);
            // init previous placeholder state by first character
            if (prevPlaceholder === undefined) {
                prevPlaceholder = placeholder;
            }

            if (placeholder !== prevPlaceholder) {
                prevPlaceholder = placeholder;
                i++;
            }

            if (placeholder) {
                // placeholder
                if (i === sections.length) sections[i] = 1;
                else sections[i]++;
            } else {
                // separator
                if (i === sections.length) sections[i] = c;
                else sections[i] += c;
            }
        }
        return sections;
    },
    getNumberFormatMaxLength: (maxlenght: number, fraction?: number) => {
        let totalLength = maxlenght;
        if (fraction) {
            totalLength += fraction + 1;
        }
        const numberDot = Math.floor((maxlenght - 1) / 3);
        totalLength += numberDot;
        return totalLength;
    },
    //format date with format YYYY/MM/DD (Weekday)
    formatDateWithWeekDay: (date: any) => {
        if (!date) return '';
        return dayjs(date).locale('ja').format('YYYY/MM/DD (dd)');
    },
    formatDate: (date: any, format: string) => {
        if (!date) return '';
        return dayjs(date).locale('ja').format(format);
    },
    replace: (value: string) => {
        return value.replaceAll(',', '');
    },
  
    
    canAccess: (path: string, userInfo?: User) => {
        const isPublicPath = PUBLIC_PATHS_WITH_DYNAMIC_ID.some((publicPath) => {
            return matchPath({ path: publicPath }, path);
        });
        if (isPublicPath) return true;
        const menuSetting = PRIVATE_ROUTES_RANK.find((item) => {
            return path.indexOf(item.path) > -1;
        });
        //Menu is not setting -> can access
        if (!menuSetting) return true;
        const accessRanks: string[] | null = menuSetting.ranks;
        //Menu has rank = null -> can access because it is public and don't need user login
        if (!accessRanks) return true;
        //Menu has rank -> check if user login
        if (!userInfo) return false;
        //if user login -> check if user has rank
        //If not -> default rank is normal
        const userRank = userInfo.accountRank ?? ACCOUNT_RANK.NORMAL;
        //check if user has rank in access rank
        return accessRanks.includes(userRank);
    },
    getListMenuDisplay: (listMenu: any[], userInfo?: User) => {
        return listMenu?.filter((item) => {
            return commonHelpers.canAccess(item.key, userInfo);
        });
    },
    acceptFile: (fileType: string, acceptedFileTypes: string[]) => {
        const data = acceptedFileTypes?.find((item) => {
            if (fileType == item) {
                return true;
            } else if (item.match('([a-z])*/\\*')) {
                const regex = new RegExp(`${item}([a-z])*`);
                return fileType.match(regex);
            }
            return false;
        });

        return data ? true : false;
    },
    validateFileTypes: (file: File | UploadFile, acceptedFileTypes: string[]) => {
        const isAcceptFile = commonHelpers.acceptFile(file.type ?? '', acceptedFileTypes);
        if (!isAcceptFile) {
            return acceptedFileTypes?.map((type: string) => {
                const fileMimeType =  FILE_EXTENSION[type as keyof typeof FILE_EXTENSION];
                if(fileMimeType) return fileMimeType.map((item) => item.toLocaleUpperCase()).join('、');
                const fileType = type.match('([a-z])*/\\*') 
                    ? type.split('/').at(0)?.toLocaleUpperCase()
                    : type.split('/').at(1)?.toLocaleUpperCase();
                return fileType
            }).sort().filter(function(item, pos, ary) {
                return !pos || item != ary[pos - 1];
            }).join('、');
        }
        return '';
    },
    validateFileSize: (file: File | UploadFile, maxFileSize: any) => {
        //convert to MB
        return (file.size ?? 0) / 1024 / 1024 < (Number(maxFileSize) ?? 2);
    },
    toASCII: (chars: string) => {
        if(!chars) return chars;
        let ascii = '';
        for(let i=0, l=chars.length; i<l; i++) {
            let c = chars[i].charCodeAt(0);
            // make sure we only convert half-full width char
            if (c >= 0xFF00 && c <= 0xFFEF) {
               c = 0xFF & (c + 0x20);
            }
            ascii += String.fromCharCode(c);
        }
        return ascii;
    },
    setCookie: (name: string, value: string, days: number = 365) => {
        const expires = new Date();
        expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
        const isSecure = window.location.protocol === 'https:';
        const secureFlag = isSecure ? ';Secure' : '';
        document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax${secureFlag}`;
    },
    getCookie: (name: string): string | null => {
        const nameEQ = name + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    deleteCookie: (name: string) => {
        const isSecure = window.location.protocol === 'https:';
        const secureFlag = isSecure ? ';Secure' : '';
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;SameSite=Lax${secureFlag}`;
    }
};
